import { render, staticRenderFns } from "./CurrentPlanStep.vue?vue&type=template&id=db1e0652&lang=pug"
import script from "./CurrentPlanStep.vue?vue&type=script&lang=js"
export * from "./CurrentPlanStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports